module.exports = __webpack_public_path__ + "069a6da5fb4a9b2970ec0bcff7bef04d.pdf";